import { removeQueryString } from '../../utils/stringHelpers'

function swatchClass (iconClass, value) {
  if (iconClass === 'colour') {
    const map = window.__colorSwatchMap || {}
    return `vsd-colour-${map[value] || value}`
  }
  return `vsd-${iconClass}-${value}`
}

function refinementTemplateInnerTag (hit, iconClass) {
  if (iconClass) {
    return `
      <label class="ais-RefinementList-label ais-swatches">
        <input type="checkbox" class="ais-RefinementList-checkbox" value="${hit.label}" ${hit.isRefined ? 'checked' : ''}>
        <span class="ais-RefinementList-labelText">
          <span class="${swatchClass(iconClass, hit.value)}"></span>
          <span>${hit.label}</span>
        </span>` +
        (hit.count ? `<span class="ais-RefinementList-count">${hit.count}</span>` : '') +
      '</label>'
  } else {
    return `
      <label class="ais-RefinementList-label">
        <input type="checkbox" class="ais-RefinementList-checkbox" value="${hit.label}" ${hit.isRefined ? 'checked' : ''}>
        <span class="ais-RefinementList-labelText">${hit.label}</span>` +
        (hit.count ? `<span class="ais-RefinementList-count">${hit.count}</span>` : '') +
      '</label>'
  }
}

export function refinementListItemTemplate (hit, iconClass) {
  const facetUrl = removeQueryString(hit.url)
  const outerTag = `<a href="${facetUrl}">`
  const currentPage = removeQueryString(window.location.href)

  if (facetUrl === '#' || facetUrl === currentPage) {
    return refinementTemplateInnerTag(hit, iconClass)
  } else {
    return outerTag + refinementTemplateInnerTag(hit, iconClass) + '</a>'
  }
}
